import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";
import { pack } from "./alert";

export const list = () => async (dispatch) => {
  try {
    const res = await api.get("/accounts/reconciliations");
    return res.data?.items || [];
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const get = (uuid) => async (dispatch) => {
  try {
    if (!isGuid(uuid)) return null;
    const res = await api.get(`/accounts/reconciliations/i/${uuid}`);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const candidates = ({ uuid, financialAccountUuid }) => async (dispatch) => {
  try {
    const url = isGuid(uuid)
      ? `/accounts/reconciliations/i/${uuid}/candidates`
      : `/accounts/reconciliations/financial/${financialAccountUuid}/candidates`;
    const res = await api.get(url);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const save = (payload = {}) => async (dispatch) => {
  try {
    const res = await api.post("/accounts/reconciliations", payload);
    dispatch(pack(["bank reconciliation saved"], "success"));
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const finalize = (uuid) => async (dispatch) => {
  try {
    if (!isGuid(uuid)) return null;
    const res = await api.post(`/accounts/reconciliations/i/${uuid}/finalize`);
    if (res.data?.success !== false) dispatch(pack(["bank reconciliation finalized"], "success"));
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const destroy = (uuid) => async (dispatch) => {
  try {
    if (!isGuid(uuid)) return null;
    const res = await api.delete(`/accounts/reconciliations/i/${uuid}`);
    dispatch(pack(["bank reconciliation deleted"], "success"));
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const adjustment = (payload = {}) => async (dispatch) => {
  try {
    const res = await api.post("/accounts/reconciliations/adjustments", payload);
    if (res.data?.success !== false) dispatch(pack(["reconciliation adjustment added"], "success"));
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};
